const lang = {
  uk: {
    unlimitedAccess: 'Необмежений в часі доступ',
    thoroughlyDesignedComplexityProgression:
      'Ретельно прораховане збільшення складності&nbsp;уроків',
    phoneSupport: 'Телефонна підтримка',
    additionalBonusLessons:
      'Додаткові бонусні уроки у&nbsp;подарунок (32&nbsp;основних&nbsp;+&nbsp;24&nbsp;бонусних)',
    reducedPrice: 'Економія',
    nextLessonShort: '1 урок',
    nextLesson: 'Наступний урок',
    threeNextLessonsShort: '3 уроки',
    threeNextLessons: 'Три наступні уроки',
    currencyCode: 'грн.',
    fullCourse: 'Повний курс, 32&nbsp;уроки',
    courseName: 'Тестовий курс',
  },
  en: {
    oneNextLessonChosen:
      'You have chosen to purchase 1 next lesson. Access will be open until the 12th lesson inclusive.',
    threeNextLessonsChosen:
      'You have chosen to purchase the following 3 lessons. Access will be open until lesson 14 inclusive.',
    fullCourseChosen:
      'You have chosen to purchase the full course (32 lessons + 16 bonus).',
    unlimitedAccess: 'Unlimited access',
    thoroughlyDesignedComplexityProgression:
      'Carefully calculated increase in the complexity of lessons',
    phoneSupport: 'Phone support',
    additionalBonusLessons:
      'Additional bonus lessons as a gift (32 basic +16 bonus)',
    reducedPrice: 'Reduced price',
    nextLesson: 'Next lesson',
    threeNextLessons: 'Next three lessons',
    currencyCode: 'UAH',
    fullCourse: 'Full course, 32 lessons',
    courseName: 'Test course',
    getAccess: 'Get access',
  },
};

export default lang['uk'];
